import SubmissionsTab from "./SubmissionsTab";

export default function CompanySubmissionsTab(props) {
  return <SubmissionsTab {...props} collectionName="companySubmissions" label="Company Submissions"
    summaryKeys={["companyName", "contactPerson"]}/>;
}
